import promise from 'bluebird'
import { loadAccess } from '../component/permissions/access';

import { hairdresserConstants, alertConstants, userConstants } from '../_constants';

import { userService } from "../_services";

import { ResponseFilter } from "../config/response-handler";

// Export will be at the end of the file after all functions are defined


function login(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            params.latitude = "28.640004"
            params.longitude = "77.376707"

            dispatch(request(params));
            userService.login(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    if (serverResponseData.data) {
                        let data = serverResponseData.data;
                        localStorage.setItem('accessToken', data.tokenInfo.accessToken);
                        localStorage.setItem('refreshToken', data.tokenInfo.refreshToken);
                        localStorage.setItem('expiresIn', data.tokenInfo.expiresIn);
                        localStorage.setItem('tokenType', data.tokenInfo.tokenType);
                        localStorage.setItem('userId', data.userInfo.userId);
                        if(data.userInfo.hairdresser&&data.userInfo.hairdresser.salon){
                         localStorage.setItem('salonId', data.userInfo.hairdresser.salon._id);
                        }
                        localStorage.setItem('defaultRedirectTo', data.userInfo.defaultRedirectTo);
                        // Store full user object for Finance and CashUp components
                        localStorage.setItem('user', JSON.stringify(data.userInfo));
                        // Roles & permissions for the location they signed in at.
                        loadAccess();
                    }

                    if (serverResponseData && serverResponseData.data) dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(loginRequest) { return { type: userConstants.LOGIN_REQUEST, loginRequest } }
    function success(loginSuccess) { return { type: userConstants.LOGIN_SUCCESS, loginSuccess } }
    function failure(loginFail) { return { type: userConstants.LOGIN_ERROR, loginFail } }
}

function signup(apiParams) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            apiParams.latitude = "28.640004"
            apiParams.longitude = "77.376707"

            dispatch(request(apiParams));
            userService.signup(apiParams)
                .then(response => {
                    let { serverResponseData } = ResponseFilter(response);
                    // Persist the session BEFORE resolving, and tolerate both
                    // response envelopes (v1 `data`, v2 `responseData.data`).
                    // The old order resolved first and assumed one shape — a
                    // mismatch or throw here was swallowed, so the caller saw
                    // "success" and redirected a logged-OUT user out of the
                    // booking flow.
                    const body = serverResponseData || {};
                    const data = body.data
                        || (body.responseData && (body.responseData.data || body.responseData))
                        || null;
                    if (data && data.tokenInfo && data.tokenInfo.accessToken) {
                        localStorage.setItem('accessToken', data.tokenInfo.accessToken);
                        localStorage.setItem('refreshToken', data.tokenInfo.refreshToken || '');
                        localStorage.setItem('expiresIn', data.tokenInfo.expiresIn);
                        localStorage.setItem('tokenType', data.tokenInfo.tokenType);
                        if (data.userInfo && data.userInfo.userId) {
                            localStorage.setItem('userId', data.userInfo.userId);
                            // Store full user object for Finance and CashUp components
                            localStorage.setItem('user', JSON.stringify(data.userInfo));
                        }
                    }
                    // Only a real session payload goes into the store. An
                    // 'email exists' / 'claim sent' reply carries no user —
                    // dispatching null made every connected header crash on
                    // user.userInfo and killed the booking signup flow.
                    if (data) dispatch(success(data));
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(signupRequest) { return { type: userConstants.SIGNUP_REQUEST, signupRequest } }
    function success(signupSuccess) { return { type: userConstants.SIGNUP_SUCCESS, signupSuccess } }
    function failure(signupFail) { return { type: userConstants.SIGNUP_ERROR, signupFail } }
}

function socialLogin(apiParams) {

    return function (dispatch) {
        return new promise(function (resolve, reject) {
            apiParams.latitude = "28.640004"
            apiParams.longitude = "77.376707"

            dispatch(request(apiParams));
            userService.socialLogin(apiParams).then(response => {
                    let { serverResponseData } = ResponseFilter(response);
                    // A private-relay Apple sign-in answers { needsEmail } with no
                    // session yet — only a reply carrying tokens logs anyone in.
                    const hasSession = !!(serverResponseData && serverResponseData.data && serverResponseData.data.tokenInfo);
                    if (hasSession) {
                        let data = serverResponseData.data;
                        localStorage.setItem('accessToken', data.tokenInfo.accessToken);
                        localStorage.setItem('refreshToken', data.tokenInfo.refreshToken);
                        localStorage.setItem('expiresIn', data.tokenInfo.expiresIn);
                        localStorage.setItem('tokenType', data.tokenInfo.tokenType);
                        localStorage.setItem('userId', data.userInfo.userId);
                        // Store full user object for Finance and CashUp components
                        localStorage.setItem('user', JSON.stringify(data.userInfo));
                    }
                    if (hasSession) dispatch(success(serverResponseData.data));
                    // Resolve AFTER the session is saved — callers redirect on it.
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(signupRequest) { return { type: userConstants.SIGNUP_REQUEST, signupRequest } }
    function success(signupSuccess) { return { type: userConstants.SIGNUP_SUCCESS, signupSuccess } }
    function failure(signupFail) { return { type: userConstants.SIGNUP_ERROR, signupFail } }
}

function sendSignupVerificationCode(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            userService.sendSignupVerificationCode(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function verifySignupCode(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            userService.verifySignupCode(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function checkEmailExists(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            userService.checkEmailExists(params)
                .then(response => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function resetPasswordAndLogin(params) {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            userService.resetPasswordAndLogin(params)
                .then(response => {
                    let { serverResponseData } = ResponseFilter(response);
                    // Persist BEFORE resolving (see signup above) and accept
                    // both envelopes: v2 `responseData.data`, bare
                    // `responseData`, or v1 `data`.
                    const body = serverResponseData || {};
                    const data = (body.responseData && (body.responseData.data || body.responseData))
                        || body.data
                        || null;

                    if (data && data.tokenInfo && data.tokenInfo.accessToken) {
                        localStorage.setItem('accessToken', data.tokenInfo.accessToken);
                        localStorage.setItem('refreshToken', data.tokenInfo.refreshToken || '');
                        localStorage.setItem('expiresIn', data.tokenInfo.expiresIn);
                        localStorage.setItem('tokenType', data.tokenInfo.tokenType);
                        if (data.userInfo && data.userInfo.userId) {
                            localStorage.setItem('userId', data.userInfo.userId);
                            // Store full user object for Finance and CashUp components
                            localStorage.setItem('user', JSON.stringify(data.userInfo));
                        }
                    }
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                })
        })
    };
}

function profile(params) {
    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            userService.getProfile(params)
                .then(response => {
                    // console.log("##get profile,",response)
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    if (serverResponseData && serverResponseData.data) dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    // console.log("##get profile err",err);
                    //localStorage.clear();
                    //window.location.reload();
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(profileRequest) { return { type: userConstants.PROFILE_REQUEST, profileRequest } }
    function success(profileSuccess) { return { type: userConstants.PROFILE_SUCCESS, profileSuccess } }
    function failure(profileFail) { return { type: userConstants.PROFILE_ERROR, profileFail } }
}


function logout(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            params.deviceToken = 'sfsafdsfsafsa';
            const apiParam = new URLSearchParams();
            apiParam.append('deviceToken', 'sadsadsadas');
            apiParam.append('userId', params.userId);

            dispatch(request(apiParam));
            userService.logout(apiParam, params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    if (serverResponseData && serverResponseData.data) dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(profileRequest) { return { type: userConstants.PROFILE_REQUEST, profileRequest } }
    function success(logoutSuccess) { return { type: userConstants.LOGOUT_SUCCESS, logoutSuccess } }
    function failure(profileFail) { return { type: userConstants.PROFILE_ERROR, profileFail } }
}

function forgot(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            userService.forgot(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    if (serverResponseData.data) {
                        let data = serverResponseData.data;
                    }
                    if (serverResponseData && serverResponseData.data) dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(forgotRequest) { return { type: userConstants.FORGOT_REQUEST, forgotRequest } }
    function success(forgotSuccess) { return { type: userConstants.FORGOT_SUCCESS, forgotSuccess } }
    function failure(forgotFail) { return { type: userConstants.FORGOT_ERROR, forgotFail } }
}


function reset(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {

            dispatch(request(params));
            userService.reset(params)
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    if (serverResponseData.data) {
                        let data = serverResponseData.data;
                    }
                    if (serverResponseData && serverResponseData.data) dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(resetRequest) { return { type: userConstants.RESET_REQUEST, resetRequest } }
    function success(resetSuccess) { return { type: userConstants.RESET_SUCCESS, resetSuccess } }
    function failure(resetFail) { return { type: userConstants.RESET_ERROR, resetFail } }
}


function changePassword(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {
            params.deviceToken = 'sfsafdsfsafsa';
            dispatch(request(params));
            userService.changePassword(params)
                .then(response => {
                    // console.log(response,'jhtgyhedede');
                    
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    if (serverResponseData.data) {
                        let data = serverResponseData.data;
                    }
                    dispatch(success(serverResponseData.data.reviews));
                })
                .catch((err) => {
                    // console.log(err,'jhtgyhbgbgedede');
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(changePasswordRequest) { return { type: userConstants.CHANGEPASSWORD_REQUEST, changePasswordRequest } }
    function success(changePasswordSuccess) { return { type: userConstants.CHANGEPASSWORD_SUCCESS, changePasswordSuccess } }
    function failure(changePasswordFail) { return { type: userConstants.CHANGEPASSWORD_ERROR, changePasswordFail } }
}


function editClientProfile(params) {

    return function (dispatch) {

        return new promise(function (resolve, reject) {
            dispatch(request(params));
            userService.editClientProfile(params)
                .then(response => {

                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    if (serverResponseData.data) {
                        let data = serverResponseData.data;
                    }
                    if (serverResponseData && serverResponseData.data) dispatch(success(serverResponseData.data));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));

                })
        })
    };
    function request(editClientRequest) { return { type: userConstants.EDITCLIENT_REQUEST, editClientRequest } }
    function success(editClientSuccess) { return { type: userConstants.EDITCLIENT_SUCCESS, editClientSuccess } }
    function failure(editClientFail) { return { type: userConstants.EDITCLIENT_ERROR, editClientFail } }
}

function clientProfile() {
    return function (dispatch) {
        return new promise(function (resolve, reject) {
            dispatch(request());
            userService.getClientProfile()
                .then(response => {
                    resolve(response);
                    let { serverResponseData } = ResponseFilter(response);
                    // The v2 API returns data in responseData
                    const profileData = serverResponseData.responseData || serverResponseData.data;
                    dispatch(success(profileData));
                })
                .catch((err) => {
                    reject(err);
                    dispatch(failure(err));
                })
        })
    };
    function request() { return { type: userConstants.CLIENT_PROFILE_REQUEST } }
    function success(clientProfileSuccess) { return { type: userConstants.CLIENT_PROFILE_SUCCESS, clientProfileSuccess } }
    function failure(clientProfileFail) { return { type: userConstants.CLIENT_PROFILE_ERROR, clientProfileFail } }
}

// Export all actions at the end of the file
export const userActions = {
    login,
    signup,
    profile,
    clientProfile,
    logout,
    forgot,
    reset,
    changePassword,
    editClientProfile,
    socialLogin,
    sendSignupVerificationCode,
    verifySignupCode,
    resetPasswordAndLogin,
    checkEmailExists
};

